
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useMeetings } from "../../hooks/useMeetings";
import { DashboardMeetingCard } from "./DashboardMeetingCard";
import { Button } from "../ui/button";
import React from "react";

export function DashboardMeetingsList() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: meetings = [], isLoading } = useMeetings(user?.id);

  const handleViewAll = () => {
    navigate('/app/meetings');
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((n) => (
          <div key={n} className="h-24 bg-muted animate-pulse rounded-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden border-2 border-slate-300 dark:border-slate-700 rounded-3xl bg-slate-200  dark:bg-slate-700/50 p-4">
      <div className="relative z-10">
        <h2 className="text-lg font-bold mb-2 px-2 text-foreground">Recent Meetings</h2>
        
        <div className="space-y-2">
          {meetings.slice(0, 5).map((meeting) => (
            <DashboardMeetingCard key={meeting.id} meeting={meeting} />
          ))}
        </div>

        {meetings.length > 5 && (
          <div className="mt-6 flex justify-end px-4">
            <Button
              onClick={handleViewAll}
              className="button button-default"
            >
              View all meetings
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
